import { motion } from "framer-motion";

export const CtaButton = ({
  onClick,
  testId = "cta-button",
  className = "",
  text = "Попробовать бесплатно 1 день",
}) => (
  <motion.button
    type="button"
    data-testid={testId}
    onClick={onClick}
    whileHover={{ scale: 1.04 }}
    whileTap={{ scale: 0.96 }}
    transition={{ type: "spring", stiffness: 400, damping: 17 }}
    className={`inline-flex w-full items-center justify-center rounded-full bg-nora-accent px-8 py-4 text-center font-display text-sm font-bold leading-snug text-[#1F2730] shadow-xl shadow-nora-accent/25 transition-colors hover:bg-nora-accenthover sm:w-auto sm:text-base ${className}`}
  >
    {text}
  </motion.button>
);
